import React, { Component } from 'react'
import onClickOutside from 'react-onclickoutside'
import { useDispatch } from 'react-redux'
import { Button } from 'reactstrap'
import './style.css'
import { useSelector } from 'react-redux'

function SelectedItemsContent(props) {
  const dispatch = useDispatch()
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  console.log(language.general)

  return (
    <div
      className='selected-items-wrapper'
      style={{ overflowX: 'hidden !important' }}
    >
      {/* <p>{language.groups ? language.groups.show_selected_items : null}</p> */}
      <div
        className='scrollbar selected-items-list '
        style={{ overflowX: 'hidden !important' }}
      >
        {props.selectedItems.length ? (
          <ul className='list-unstyled'>
            {props.items.map((item, index) => (
              <li key={item.id}>
                {props.hasDisabledProperty ? (
                  <div className='custom-control custom-checkbox-info mb-0'>
                    <input
                      className='custom-control-input'
                      id={`checkbox${index}`}
                      type='checkbox'
                      checked={true}
                      onChange={() => dispatch(props.onChange(item.id))}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor={`checkbox${index}`}
                    >
                      {props.isUsersSelect
                        ? item.first_name + ' ' + item.last_name
                        : item.name}
                    </label>
                  </div>
                ) : (
                  <div className='custom-control custom-checkbox-info mb-0'>
                    <input
                      className='custom-control-input'
                      id={`checkbox${index}`}
                      type='checkbox'
                      checked={true}
                      onChange={() => dispatch(props.onChange(item.id))}
                    />
                    <label
                      className='custom-control-label'
                      htmlFor={`checkbox${index}`}
                    >
                      {props.isUsersSelect
                        ? item.first_name + ' ' + item.last_name
                        : item.name}
                    </label>
                  </div>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p className='no-selected-items-message'>
            {language.general ? language.general.not_selected_items : null}
          </p>
        )}
      </div>
      <div className='modules-options' style={{}}>
        <button
          onClick={() => props.setHideSelectedItems()}
          className='btn btn-info btn-sm px-4'
        >
          {language.general ? language.general.close : null}
        </button>
      </div>
    </div>
  )
}

class SelectedItems extends Component {
  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.props.setHideSelectedItems()
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }
  handleClickOutside = () => {
    this.props.setHideSelectedItems()
  }
  render() {
    // let language = {}
    // props.language.language ? (language = props.language.language.data) : null
    return (
      <div style={{ minWidth: '182px' }}>
        <Button
          onClick={() =>
            this.props.showSelectedItems
              ? this.props.setHideSelectedItems()
              : this.props.setShowSelectedItems()
          }
          style={{ height: '35px' }}
          className='btn btn-secondary btn-sm py-2 px-3 mb-3 d-flex align-items-center justify-content-center'
        >
          Show selected items
        </Button>
        {this.props.showSelectedItems ? (
          <SelectedItemsContent {...this.props} />
        ) : null}
      </div>
    )
  }
}
export default onClickOutside(SelectedItems)
